import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-card px-5 py-12 sm:py-20" data-id="element-171" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-172" data-mp="22mq3uf51whbt">
        <span className="mb-5 inline-block rounded-full border border-highlight bg-highlight/20 px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-foreground" data-id="element-173" data-mp="2ge4qcvy630nm">
          WSZYSTKO, CO JEST W ŚRODKU
        </span>
        <h2 className="font-display text-3xl font-bold leading-tight text-foreground sm:text-5xl" data-id="element-174" data-mp="26mqmkbz6neoo">
          Wszystko, czego dziecko potrzebuje, żeby myśleć, budować, testować i wynajdywać.
        </h2>
        <div className="mx-auto mt-6 h-px w-16 bg-primary/40" data-id="element-175" data-mp="2z9l1ktd8dlur" />
        <p className="mt-6 text-sm leading-relaxed text-foreground/75 sm:text-base" data-id="element-176" data-mp="343frwfnccz2t">
          Pracownia Małego Wynalazcy to gotowa biblioteka projektów do wydrukowania. Zdejmuje z
          Ciebie najtrudniejszą część, czyli wymyślanie, co robić dalej. Każda karta daje dziecku
          jasny start i powód, żeby odkrywać dalej.
        </p>
      </motion.div>
    </section>;
}